<template>
  <div class="skeleton-loader" :class="`skeleton-${type}`">
    <!-- profile: avatar + heading + lines -->
    <template v-if="type === 'profile'">
      <div class="skeleton-row skeleton-profile-row">
        <div class="skeleton-avatar skeleton-shimmer" />
        <div class="skeleton-profile-text">
          <div class="skeleton-line skeleton-heading skeleton-shimmer" />
          <div class="skeleton-line skeleton-shimmer" />
          <div class="skeleton-line skeleton-shimmer short" />
        </div>
      </div>
    </template>
    <!-- list-item: icon/avatar + lines -->
    <template v-else-if="type === 'list-item'">
      <div class="skeleton-row skeleton-list-row">
        <div class="skeleton-circle skeleton-shimmer" />
        <div class="skeleton-list-text">
          <div class="skeleton-line skeleton-shimmer" />
          <div class="skeleton-line skeleton-shimmer short" />
        </div>
      </div>
    </template>
    <!-- paragraph: multiple lines -->
    <template v-else-if="type === 'paragraph'">
      <div class="skeleton-paragraph">
        <div class="skeleton-line skeleton-shimmer" />
        <div class="skeleton-line skeleton-shimmer" />
        <div class="skeleton-line skeleton-shimmer short" />
      </div>
    </template>
    <!-- card (default): card-shaped block -->
    <template v-else>
      <div class="skeleton-card-inner">
        <div class="skeleton-rect skeleton-shimmer" />
        <div class="skeleton-card-content">
          <div class="skeleton-line skeleton-shimmer" />
          <div class="skeleton-line skeleton-shimmer short" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SkeletonLoader",
  props: {
    type: {
      type: String,
      default: "card", // 'card', 'list-item', 'paragraph', 'profile'
    },
  },
};
</script>

<style scoped>
.skeleton-loader {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.skeleton-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-profile-text,
.skeleton-list-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-line {
  height: 12px;
  border-radius: 4px;
  max-width: 100%;
}

.skeleton-line.short {
  max-width: 60%;
}

.skeleton-heading {
  height: 18px;
  max-width: 70%;
}

.skeleton-paragraph {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0;
}

.skeleton-card-inner {
  padding: 12px;
}

.skeleton-rect {
  height: 120px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.skeleton-card-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-profile-row {
  padding: 16px;
}

.skeleton-list-row {
  padding: 12px 16px;
}

.skeleton-profile {
  margin-bottom: 1rem;
}

.skeleton-card {
  margin-bottom: 0.75rem;
}
</style>
